<template>
  <router-view></router-view>
</template>

<script>
export default {
    name: "ap-wrapper"
};
</script>

<style>
</style>